import React, { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import NavigationDrawer from '../../components/navigationDrawer/navigationDrawer';
import { pages } from '../../../utils/common';
import { CONSTANTS } from '../../../utils/CONSTS';
import { UsersProvider } from './contexts/users.context';
import { UsersViewProps } from './users.interfaces';
import { UsersContent } from './userComponents';
import { Navigate } from 'react-router-dom';
import { useRbacState } from 'src/context/rbac.context';
import { hasAnySubmoduleReadPermission } from 'src/utils/rbacHelpers';
import { useRbacSafeLandingPath } from 'src/hooks/useRbacSafeLandingPath';
const UsersView: FC<UsersViewProps> = () => {
  const { rbac } = useRbacState();
  const safeLanding = useRbacSafeLandingPath();
  const hasAccess = useMemo(
    () => hasAnySubmoduleReadPermission(rbac, 'users'),
    [rbac]
  );

  if (!hasAccess) {
    return <Navigate to={safeLanding} replace />;
  }

  return (
    <NavigationDrawer
      selectedPage={pages.users.path}
      window={window ?? null}
      data-testid="users-view"
    >
      <Helmet>
        <title>{CONSTANTS.title.users || 'User Management'}</title>
      </Helmet>
      <UsersProvider>
        <UsersContent />
      </UsersProvider>
    </NavigationDrawer>
  );
};

export default UsersView;
